<template lang="html">
  <sc-flex :is-column="true" :is-full-width="true">
    <!-- Partial: Alert -->
    <sc-alert type="info" class="sticky">
      Please scroll down to <b>review</b> the K-1 package. After reviewing,
      click the <b>Download</b> button to save a copy.

      <sc-button-group slot="button-group">
        <sc-button type="ghost" icon-left="download" @click="downloadPdf">
          Download
        </sc-button>
      </sc-button-group>
    </sc-alert>

    <!-- Partial: Content -->
    <sc-flex :is-column="true">
      <!-- State: Loading -->
      <sc-flex
        v-if="pdfLoading"
        :is-centered="true"
        :is-column="true"
        :is-full-width="true"
      >
        <br />
        <v-progress-circular indeterminate color="primary" />
      </sc-flex>
      <!-- State: Partial Pages -->
      <section class="pdf-page-container" v-else>
        <div v-for="pageImage in pageImages">
          <img :src="pageImage.thumbnail" class="pdf" />
        </div>
      </section>
    </sc-flex>
  </sc-flex>
</template>

<script>
import API from '@/api';
import { PDFDocument } from 'pdf-lib';
import pdf from 'vue-pdf';
import TaxReturnAlert from './components/TaxReturnAlert';
import { generatePdfThumbnails } from '@/utils/pdf';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  mixins: [UtilsMixins],

  data() {
    return {
      pdfSrc: null,

      pdfLoading: false,
      pdfDoc: null,
      pdfData: null,
      pageImages: [],
    };
  },

  methods: {
    async getK1PackageDownloadLink() {
      const token = this.$route.query.token;

      const response = await API.taxReturn.getK1PackageDownloadLink({
        token,
      });

      this.pdfSrc = response.data.link;
    },

    async downloadPdf() {
      await this.downloadDocumentByLink(this.pdfSrc, 'K1_Package');
    },
  },

  async created() {
    try {
      this.pdfLoading = true;

      await this.getK1PackageDownloadLink();

      const pdfBytes = await fetch(this.pdfSrc).then(res => res.arrayBuffer());

      this.pdfDoc = await PDFDocument.load(pdfBytes);
      this.pdfData = await this.pdfDoc.saveAsBase64({ dataUri: true });
      this.pageImages = await generatePdfThumbnails(this.pdfData, 1000);
    } catch (error) {
      console.error(error);
    } finally {
      this.pdfLoading = false;
    }
  },
};
</script>

<style scoped>
.sticky {
  position: sticky;
  top: 72px;
  z-index: 2;
}
</style>
